import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './OptInItem.scss';

function OptInItem({
  fieldName,
  handleValueChange,
  isOptedIn,
  errorMessage,
  icon,
  title,
  description
}) {
  return (
    <div className={styles.optInContainer} data-cy="OptInItem">
      <div className={styles.top}>
        <h4>{title}</h4>
        <div
          className={
            fieldName === 'campaignOptIn' ? styles.oemLogo : styles.logo
          }
        >
          {icon && <img src={icon} alt="logo" />}
        </div>
      </div>
      <div className={styles.bottom}>
        <p className={styles.description}>{description}</p>

        <div
          data-cy="OptInItem-radio-box"
          className={classNames(
            errorMessage && styles.radioBoxError,
            styles.radioButtons
          )}
        >
          <div className={styles.yes} onClick={() => handleValueChange(true)}>
            <input
              data-cy="OptInItem-yes"
              type="radio"
              name={fieldName}
              checked={isOptedIn || false}
              readOnly // the surrounding div is clickable, not just the radio button
            />{' '}
            <span>Yes</span>
          </div>
          <div className={styles.no} onClick={() => handleValueChange(false)}>
            <input
              data-cy="OptInItem-no"
              type="radio"
              name={fieldName}
              checked={isOptedIn === false || false}
              readOnly // the surrounding div is clickable, not just the radio button
            />{' '}
            <span>No</span>
          </div>
        </div>
      </div>
      {errorMessage && (
        <div data-cy="OptInItem-error-msg" className={styles.error}>
          {errorMessage}
        </div>
      )}
    </div>
  );
}

OptInItem.propTypes = {
  fieldName: PropTypes.string,
  isOptedIn: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  handleValueChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired
};

export default OptInItem;



// WEBPACK FOOTER //
// ./src/components/OptIn/OptInItem/OptInItem.js